var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 780,
    viewBox: "0 0 1440 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 711.588L1380 692.734C1320 673.88 1200 636.171 1080 648.741C960 661.31 840 724.157 720 755.581C600 787.005 480 787.005 360 761.866C240 736.727 120 686.449 60 661.31L0 636.171V0L60 0C120 0 240 0 360 0C480 0 600 0 720 0C840 0 960 0 1080 0C1200 0 1278.5 0 1338.5 0H1440V711.588Z",
    fill: "url(#paint0_linear_3033_7646)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3033_7646",
    x1: 1440,
    y1: 780.197,
    x2: 113.02,
    y2: -159.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982292,
    stopColor: "#FFC3A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.6ace44f88b2a2b7ebff5ba335df74dbd.svg";
export { ForwardRef as ReactComponent };